import React from 'react'
import Switch from '@material-ui/core/Switch'
import {
  Typography,
  Grid,
  Chip,
  FormControlLabel,
  Box,
} from '@material-ui/core'
import { useDispatch } from 'react-redux'
import settingsStyles from '../settingsStyles'
import { trackEvent } from '../../../helpers/analytics'

function PageLink({ title, description, action, state, section = 'Settings' }) {
  const classes = settingsStyles()
  const dispatch = useDispatch()

  const handleToggle = () => {
    trackEvent(dispatch, {
      eventName: 'uxp_settings_toggle',
      module: 'Settings',
      object: 'PageToggle',
      action: 'Click',
      actionContext: section,
      actionContextValue: `${title}: ${!state ? 'On' : 'Off'}`,
    })
    action(!state)
  }

  return (
    <Grid
      container
      className={classes.fullWidth}
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          handleToggle()
        }
      }}
    >
      <FormControlLabel
        className={classes.fullWidthLabel}
        control={
          <Switch
            checked={state}
            onChange={handleToggle}
            color="primary"
            name="adminMode"
            tabIndex={-1}
            onClick={(e) => e.stopPropagation()}
          />
        }
        label={
          <Grid
            container
            direction="row"
            alignItems="center"
            justify="space-between"
          >
            <Box>
              <Typography variant="h6">{title}</Typography>
              <Typography variant="caption" color="textSecondary">
                {description}
              </Typography>
            </Box>

            {state && (
              <Box mr={2}>
                <Chip
                  className={classes.pageToggleChip}
                  color="primary"
                  size="small"
                  label="Action Successful"
                />
              </Box>
            )}
          </Grid>
        }
      />
    </Grid>
  )
}

export default PageLink
